module.exports = __webpack_public_path__ + "media/new/red-64-9b632796.png";